import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useUserMenuStyles = makeStyles((theme) =>
  createStyles({
    activeLink: {
      '& *': {
        color: theme.palette.primary.main
      }
    },

    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: theme.palette.grey.A400,
      textDecoration: 'none'
    },

    logoLink: {
      marginTop: '46px',
      marginLeft: '18px'
    },

    exit: {
      marginLeft: -25,
      '& .MuiTypography-body1': {
        fontWeight: 600,
        fontFamily: 'Montserrat',
        fontSize: 15
      }
    },

    shopMenuAvatar: {
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        marginLeft: 16,
        marginTop: 40,
        marginBottom: 20
      }
    },

    userInfo: {
      marginLeft: 16,
      maxWidth: 290
    },

    headerLang: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between'
    },

    lang: {
      display: 'flex',
      alignItems: 'center'
    },

    btnRu: {
      fontFamily: 'Montserrat',
      fontSize: 14,
      textTransform: 'none',
      minWidth: 34,
      minHeight: 20
    },

    btnEng: {
      fontFamily: 'Montserrat',
      fontSize: 14,
      textTransform: 'none',
      minWidth: 44,
      minHeight: 20,
      marginRight: 11
    },

    linkDividerLang: {
      height: 16,
      borderRight: '1px solid #9E9E9E'
    },

    menu: {
      width: 360,

      [theme.breakpoints.down('md')]: {
        width: 300
      }
    },

    exitIcon: {
      minWidth: 46
    },

    link: {
      textDecoration: 'none'
    },

    linkSubs: {
      paddingRight: 5,
      fontSize: 17,
      color: 'rgba(0, 0, 0, 0.87)',
      fontFamily: 'Montserrat',
      fontWeight: 500,
      textTransform: 'none'
    },

    linkDivider: {
      height: 23,
      borderRight: '1px solid #9E9E9E',
      marginLeft: 10,
      marginRight: 10
    },

    buttonAuth: {
      marginLeft: 10,
      textTransform: 'none',
      fontSize: 16
    },

    poper: {
      marginRight: 20
    },

    drawer: {
      [theme.breakpoints.up('lg')]: {
        display: 'none'
      }
    },

    icon: {
      marginRight: 20,

      [theme.breakpoints.down('md')]: {
        marginRight: 35
      }
    },

    menuWrapper: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      marginTop: 4,

      [theme.breakpoints.down('md')]: {
        marginRight: 8
      }
    },

    iconBtn: {
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },

    iconBtnText: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 12,
      color: '#212121',
      textTransform: 'none',
      '& span': {
        fontSize: 16,
        fontFamily: 'Montserrat',
        fontWeight: 500
      }
    },

    iconBtnTextActive: {
      color: '#E64147'
    }
  })
)
